export enum ApiStatus {
    tokenInvalid = 'Token is Invalid',
    tokenExpired = 'Token is Expired'
}
